import { render, staticRenderFns } from "./PrestationItems.vue?vue&type=template&id=74f5457a&"
import script from "./PrestationItems.vue?vue&type=script&lang=js&"
export * from "./PrestationItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports